import {
    SUPPORTER_COMMENTS_RECEIVE,
    SUPPORTER_COMMENTS_ADD,
    SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE,
    SUPPORTER_COMMENTS_ADD_RECEIVE,
    SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR,
    SUPPORTER_COMMENTS_UNDO_ADD_EDIT,
    SUPPORTER_COMMENTS_DELETE_REQUEST
} from "../config/actions";

let defaultState = {
    supporterId: null,
    comments: [],
    addEditText: null,
    edit: false,
    add: false,
    loading: false,
    errors: false
};

const supporterCommentsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(SUPPORTER_COMMENTS_RECEIVE):
            return Object.assign({}, state, {
                id: action.data.id,
                comments: action.data.comments
            });
        case(SUPPORTER_COMMENTS_ADD):
            return Object.assign({}, state, {
                addEditText: '',
                edit: false,
                add: true,
                loading: false,
                errors: false
            });
        case(SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE):
            return Object.assign({}, state, {
                addEditText: action.message
            });
        case(SUPPORTER_COMMENTS_ADD_RECEIVE):
            return Object.assign({}, state, {
                addEditText: null,
                add: false,
                loading: false,
                errors: false
            });
        case(SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR):
            return Object.assign({}, state, {
                loading: false,
                errors: action.data.errors
            });
        case(SUPPORTER_COMMENTS_UNDO_ADD_EDIT):
            return Object.assign({}, state, {
                addEditText: null,
                add: false,
                edit: false,
                loading: false,
                errors: false
            });
        case(SUPPORTER_COMMENTS_DELETE_REQUEST):
            let comments = JSON.parse(JSON.stringify(state.comments)).filter((comment) => {
                return comment.id !== action.data.commentId
            });
            return Object.assign({}, state, {
                comments: comments
            });
        default:
            return state;
    }
};

export default supporterCommentsReducer;